import { featureRoute } from '../../../../src/routes/helpers';
import { AutoDelayRepayPages } from '../../../../src/constants/AppConstants';

export default featureRoute('enableAutoDelayRepay', AutoDelayRepayPages.SUBSCRIPTION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/autoDelayRepay/subscription').default);
        }, 'auto-delayrepay-subscription');
    }
});
